import { render } from "./SerialMail.vue?vue&type=template&id=07b2a292"
import script from "./SerialMail.vue?vue&type=script&lang=js"
export * from "./SerialMail.vue?vue&type=script&lang=js"
script.render = render

export default script